import React from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { useSelector } from "react-redux";

export default function LoaderContainer() {
  let { isLoading } = useSelector((state) => state.loader);

  return (
    <>
      {isLoading ? (
        <div className="loader-overlay">
          <ProgressSpinner
            style={{ width: "50px", height: "50px", position: "absolute" }}
            strokeWidth="8"
            animationDuration="1s"
          />
        </div>
      ) : null}
    </>
  );
}
